import multiguard from "vue-router-multiguard";
import {
    redirectLogin,
    loginRequired,
    isGuest,
    isVerifiedCellphone,
    isVerifiedEmail,
    isRequestCellphoneForgetPassword,
    isVerifiedCellphoneForSmsVerification, needPhoneVerification,
} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/RouterGuards";


import DefaultRouterTemplate from "../siteComponents/DefaultRouterTemplate";
import HomeView from "../siteComponents/Home";
import SiteTemplate from "../SiteTemplate";
import NotFound from "../siteComponents/NotFound";
import Suspend from "../siteComponents/Suspend.vue";

export let siteRoutesTemplateChild = [
    {
        path: '/',
        name: 'Home',
        components: {site: HomeView}
    },
    {
        path: '/login',
        name: 'Login',
        components: {site: DefaultRouterTemplate},
        beforeEnter: multiguard([redirectLogin]),
    },
    {
        path: '/register',
        name: 'Register',
        components: {site: DefaultRouterTemplate},
        beforeEnter: multiguard([redirectLogin]),
    },
    {
        path: '/verified-cellphone',
        name: 'VerifiedCellphone',
        components: {site: DefaultRouterTemplate},
        beforeEnter: multiguard([loginRequired, isVerifiedCellphoneForSmsVerification]),
    },
    {
        path: '/forget-password',
        name: 'ForgetPassword',
        components: {site: DefaultRouterTemplate},
        beforeEnter: multiguard([redirectLogin]),

    },
    {
        path: '/cellphone-reset-password',
        name: 'CellphoneResetPassword',
        components: {site: DefaultRouterTemplate},
        beforeEnter: multiguard([redirectLogin, isRequestCellphoneForgetPassword]),

    },
    {
        path: '/email/reset/password/:token/:email',
        name: 'EmailResetPassword',
        components: {site: DefaultRouterTemplate},
        beforeEnter: multiguard([redirectLogin]),
    },
    {
        path: '/auth/email/verified/:id/:hash',
        name: 'VerifiedEmail',
        components: {site: DefaultRouterTemplate},
        beforeEnter: multiguard([loginRequired]),

    },
    {
        path: '/products',
        name: 'Products',
        components: {site: DefaultRouterTemplate},
    },
    {
        path: '/product/:name',
        name: 'Product',
        components: {site: DefaultRouterTemplate},
    },
    {
        path: '/delivery',
        name: 'Delivery',
        components: {site: DefaultRouterTemplate},
        beforeEnter: multiguard([loginRequired, isVerifiedCellphone]),
    },
    {
        path: '/shopping-cart',
        name: 'ShoppingCart',
        components: {site: DefaultRouterTemplate},
        beforeEnter: multiguard([loginRequired, isVerifiedCellphone]),
    },
    {
        path: '/un-authenticated-shopping-cart',
        name: 'UnAuthenticatedShoppingCart',
        components: {site: DefaultRouterTemplate},
        beforeEnter: multiguard([isGuest]),
    },
    {
        path: '/factor/:orderId',
        name: 'Factor',
        components: {site: DefaultRouterTemplate},
        beforeEnter: multiguard([loginRequired, isVerifiedCellphone]),
    },
    {
        path: '/payment',
        name: 'Payment',
        components: {site: DefaultRouterTemplate},
        beforeEnter: multiguard([loginRequired, isVerifiedCellphone]),
    },
    {
        path: '/transaction/verify/order/:slug',
        name: 'verifyTransaction',
        components: {site: DefaultRouterTemplate},
    },
    {
        path: '/transaction/user/:user/order/:order/verify-payment/without-transaction',
        name: 'verifyTransactionWithoutAuthentication',
        components: {site: DefaultRouterTemplate},
    },
    {
        path: '/blog',
        name: 'Posts',
        components: {site: DefaultRouterTemplate},
    },
    {
        path: '/posts/:slug',
        name: 'SinglePost',
        components: {site: DefaultRouterTemplate},
    },
    {
        path: '/pages',
        name: 'Pages',
        components: {site: DefaultRouterTemplate},
    },
    {
        path: '/pages/:slug',
        name: 'SinglePage',
        components: {site: DefaultRouterTemplate},
    },
    {
        path: '/course',
        name: 'Courses',
        components: {site: DefaultRouterTemplate},
    },
    {
        path: '/course/:slug',
        name: 'SingleCourse',
        components: {site: DefaultRouterTemplate},
    },
    {
        path: '/course/:courseSlug/lesson/:slug',
        name: 'SingleLesson',
        components: {site: DefaultRouterTemplate},
    },
    {
        path: '/categories',
        name: 'Categories',
        components: {site: DefaultRouterTemplate}
    },
    {
        path: '/brands',
        name: 'Brands',
        components: {site: DefaultRouterTemplate}
    },
    {
        path: '/category/:slug',
        name: 'SingleCategory',
        components: {site: DefaultRouterTemplate}
    },
    {
        path: '/brand/:slug',
        name: 'SingleBrand',
        components: {site: DefaultRouterTemplate}
    },
    {
        path: '/post/categories',
        name: 'PostCategories',
        components: {site: DefaultRouterTemplate}
    },
    {
        path: '/search/type/:type/words/:words',
        name: 'Search',
        components: {site: DefaultRouterTemplate},
    },
    {
        path: '/verify-email-request',
        name: 'VerifyEmailRequest',
        components: {site: DefaultRouterTemplate},
    },
    {
        path: '/store',
        name: 'Store',
        components: {site: DefaultRouterTemplate},
    },
    {
        path: '/store/:store',
        name: 'SingleStore',
        components: {site: DefaultRouterTemplate},
    },
    {
        path: '/chat/:slug',
        name: 'SingleChat',
        components: {site: DefaultRouterTemplate},
    },
    {
        path: '/product/share/:name',
        name: 'ProductShare',
        components: {site: SiteTemplate},
        beforeEnter: multiguard([]),
    },
    {
        path: '/wish-list/:user',
        name: 'WishListUser',
        components: {site: DefaultRouterTemplate},
    },
    {
        path: '/access-denied',
        name: 'AccessDenied',
        components: {site: DefaultRouterTemplate},
    },
    {
        path: '/user/order/:slug',
        name: 'FactorWithSlug',
        components: {site: DefaultRouterTemplate},
    },
    {
        path: '/suspend',
        name: 'Suspend',
        components: {site: Suspend},
    },
    {
        path: '/:catchAll(.*)',
        name: 'NotFound',
        component: NotFound
    },
]

export let dashboardRoutesTemplateChild = [
    {
        path: '/dashboard',
        name: 'Dashboard',
        component: SiteTemplate,
        beforeEnter: multiguard([loginRequired]),
    },
    {
        path: '/profile',
        name: 'Profile',
        components: {site: SiteTemplate},
        beforeEnter: multiguard([loginRequired]),
    },
    {
        path: '/address',
        name: 'Address',
        components: {site: SiteTemplate},
        beforeEnter: multiguard([needPhoneVerification]),
    },
    {
        path: '/address/create',
        name: 'CreateAddress',
        components: {site: SiteTemplate},
        beforeEnter: multiguard([needPhoneVerification]),
    },
    {
        path: '/address/update/:id',
        name: 'UpdateAddress',
        components: {site: SiteTemplate},
        beforeEnter: multiguard([needPhoneVerification]),
    },
    {
        path: '/user-address/:id',
        name: 'UserAddresses',
        components: {site: SiteTemplate},
        beforeEnter: multiguard([needPhoneVerification]),
    },
    {
        path: '/brand',
        name: 'Brand',
        components: {site: SiteTemplate},
        beforeEnter: multiguard([needPhoneVerification]),
    },
    {
        path: '/brand/create',
        name: 'CreateBrand',
        components: {site: SiteTemplate},
        beforeEnter: multiguard([needPhoneVerification]),
    },
    {
        path: '/brand/edit/:slug',
        name: 'EditBrand',
        components: {site: SiteTemplate},
        beforeEnter: multiguard([needPhoneVerification]),
    },
    {
        path: '/brand/trash',
        name: 'TrashBrand',
        components: {site: SiteTemplate},
        beforeEnter: multiguard([needPhoneVerification]),
    },
    {
        path: '/feature',
        name: 'Feature',
        components: {site: SiteTemplate},
    },
    {
        path: '/feature/trash',
        name: 'TrashFeatures',
        components: {site: SiteTemplate},
    },
    {
        path: '/feature/create',
        name: 'CreateFeature',
        components: {site: SiteTemplate},
    },
    {
        path: '/feature/update/:id',
        name: 'UpdateFeature',
        components: {site: SiteTemplate},
    },
    {
        path: '/category',
        name: 'Category',
        components: {site: SiteTemplate},
    },
    {
        path: "/category/trash",
        name: "TrashCategory",
        components: {site: SiteTemplate},
    },
    {
        path: '/dashboard/product',
        name: 'ProductsDashboard',
        components: {site: SiteTemplate},
    },
    {
        path: '/site-info',
        name: 'SiteInfo',
        components: {site: SiteTemplate},
    },
    {
        path: '/site-info/create',
        name: 'CreateSiteInfo',
        components: {site: SiteTemplate},
    },
    {
        path: '/site-info/update/:id',
        name: 'UpdateSiteInfo',
        components: {site: SiteTemplate},
    },
    {
        path: '/dashboard/product/create',
        name: 'CreateProduct',
        components: {site: SiteTemplate},
        beforeEnter: multiguard([needPhoneVerification]),
    },
    {
        path: '/dashboard/product/edit/:slug',
        name: 'EditProduct',
        components: {site: SiteTemplate},
        beforeEnter: multiguard([needPhoneVerification]),
    },
    {
        path: '/dashboard/product/trash',
        name: 'TrashProduct',
        components: {site: SiteTemplate},
        beforeEnter: multiguard([needPhoneVerification]),
    },
    {
        path: '/user',
        name: 'User',
        components: {site: SiteTemplate},
    },
    {
        path: '/user/create',
        name: 'CreateUser',
        components: {site: SiteTemplate},
    },
    {
        path: '/user/trash',
        name: 'TrashUser',
        components: {site: SiteTemplate},
    },
    {
        path: '/user/update/:id',
        name: 'UpdateUser',
        components: {site: SiteTemplate},
    },
    {
        path: '/user/update/password/:id',
        name: 'UpdateUserPassword',
        components: {site: SiteTemplate},
    },
    {
        path: '/offer',
        name: 'Offer',
        components: {site: SiteTemplate},
    },
    {
        path: '/offer/trash',
        name: 'TrashOffer',
        components: {site: SiteTemplate},
    },
    {
        path: '/offer/update/:id',
        name: 'UpdateOffer',
        components: {site: SiteTemplate},
    },
    {
        path: '/offer/create',
        name: 'CreateOffer',
        components: {site: SiteTemplate},
    },
    {
        path: '/dashboard/user-orders',
        name: 'UserOrders',
        components: {site: SiteTemplate},
        beforeEnter: multiguard([needPhoneVerification]),

    },
    {
        path: '/dashboard/orders',
        name: 'Orders',
        components: {site: SiteTemplate},
        beforeEnter: multiguard([needPhoneVerification]),
    },
    {
        path: '/dashboard/orders/reservation',
        name: 'ReservationOrders',
        components: {site: SiteTemplate},
        beforeEnter: multiguard([needPhoneVerification]),
    },
    {
        path: '/dashboard/orders/create',
        name: 'CreateOrder',
        components: {site: SiteTemplate},
        beforeEnter: multiguard([needPhoneVerification]),

    },
    {
        path: '/dashboard/courses',
        name: 'CoursesDashboard',
        components: {site: SiteTemplate},
        beforeEnter: multiguard([needPhoneVerification]),
    },
    {
        path: '/dashboard/courses/create',
        name: 'CreateCourse',
        components: {site: SiteTemplate},
        beforeEnter: multiguard([needPhoneVerification]),
    },
    {
        path: '/dashboard/course/edit/:slug',
        name: 'EditCourse',
        components: {site: SiteTemplate},
        beforeEnter: multiguard([needPhoneVerification]),
    },
    {
        path: '/dashboard/courses/trash',
        name: 'TrashCourse',
        components: {site: SiteTemplate},
        beforeEnter: multiguard([needPhoneVerification]),
    },
    {
        path: '/dashboard/lessons',
        name: 'LessonsDashboard',
        components: {site: SiteTemplate},
        beforeEnter: multiguard([needPhoneVerification]),
    },
    {
        path: '/dashboard/create-lessons',
        name: 'CreateLessons',
        components: {site: SiteTemplate},
        beforeEnter: multiguard([needPhoneVerification]),
    },
    {
        path: '/dashboard/update-lessons/:slug',
        name: 'UpdateLessons',
        components: {site: SiteTemplate},
        beforeEnter: multiguard([needPhoneVerification]),
    },
    {
        path: '/dashboard/create-content',
        name: 'CreateContent',
        components: {site: SiteTemplate},
        beforeEnter: multiguard([needPhoneVerification]),

    },
    {
        path: '/dashboard/update-content/:slug',
        name: 'UpdateContent',
        components: {site: SiteTemplate},
        beforeEnter: multiguard([needPhoneVerification]),

    },
    {
        path: '/dashboard/posts',
        name: 'PostsDashboard',
        components: {site: SiteTemplate},
        beforeEnter: multiguard([needPhoneVerification]),
    },
    {
        path: '/dashboard/pages',
        name: 'PagesDashboard',
        components: {site: SiteTemplate},
        beforeEnter: multiguard([needPhoneVerification]),

    },
    {
        path: '/dashboard/contents/trash/:type',
        name: 'TrashContents',
        components: {site: SiteTemplate},
        beforeEnter: multiguard([needPhoneVerification]),
    },
    {
        path: '/dashboard/file-manager',
        name: 'FileManager',
        components: {site: SiteTemplate},
        beforeEnter: multiguard([needPhoneVerification]),
    },
    {
        path: '/menu-panel',
        name: 'MenuPanel',
        components: {site: SiteTemplate},
        beforeEnter: multiguard([loginRequired, needPhoneVerification]),
    },
    {
        path: '/edit-menu/:id',
        name: 'EditMenu',
        components: {site: SiteTemplate},
        beforeEnter: multiguard([loginRequired, needPhoneVerification]),
    },
    {
        path: '/comments',
        name: 'Comments',
        components: {site: SiteTemplate},
        beforeEnter: multiguard([loginRequired, needPhoneVerification]),
    },
    {
        path: '/timing',
        name: 'Timing',
        components: {site: SiteTemplate},
        beforeEnter: multiguard([loginRequired, needPhoneVerification]),
    },
    {
        path: '/add-user-to-product',
        name: 'AddUserToProduct',
        components: {site: SiteTemplate},
        beforeEnter: multiguard([loginRequired, needPhoneVerification]),
    },
    {
        path: '/dashboard/forms/formfield',
        name: 'FormField',
        components: {site: SiteTemplate},
        beforeEnter: multiguard([loginRequired, needPhoneVerification]),
    },
    {
        path: '/dashboard/forms/formcreate',
        name: 'FormCreate',
        components: {
            dashboard: SiteTemplate
        },
        beforeEnter: multiguard([loginRequired, needPhoneVerification]),
    },
    {
        path: '/dashboard/forms/create',
        name: 'CreateForm',
        components: {
            dashboard: SiteTemplate
        },
        beforeEnter: multiguard([loginRequired, needPhoneVerification]),
    },
    {
        path: '/dashboard/forms/:form/update',
        name: 'UpdateForm',
        components: {
            dashboard: SiteTemplate
        },
        beforeEnter: multiguard([loginRequired, needPhoneVerification]),
    },
    {
        path: '/user/:user/form-fill/:form_fill',
        name: 'FormAnswer',
        components: {
            dashboard: SiteTemplate
        },
        beforeEnter: multiguard([loginRequired, needPhoneVerification]),
    },
    {
        path: '/default/addresses',
        name: 'DefaultAddresses',
        components: {site: SiteTemplate},
        beforeEnter: multiguard([loginRequired, needPhoneVerification]),
    },
    {
        path: '/dashboard/deliveries',
        name: 'Deliveries',
        components: {site: SiteTemplate},
        beforeEnter: multiguard([loginRequired, needPhoneVerification]),
    },
    {
        path: '/dashboard/deliveries/create',
        name: 'CreateDelivery',
        components: {site: SiteTemplate},
        beforeEnter: multiguard([loginRequired, needPhoneVerification]),
    },
    {
        path: '/dashboard/deliveries/update/:id',
        name: 'UpdateDelivery',
        components: {site: SiteTemplate},
        beforeEnter: multiguard([loginRequired, needPhoneVerification]),
    },
    {
        path: '/dashboard/wallet/charge/:user',
        name: 'ChargeWallet',
        components: {site: SiteTemplate},
        beforeEnter: multiguard([loginRequired, needPhoneVerification]),
    },
    {
        path: '/dashboard/loans/admin',
        name: 'LoansAdmin',
        components: {site: SiteTemplate},
        beforeEnter: multiguard([loginRequired, needPhoneVerification]),
    },
    {
        path: '/dashboard/loans/user',
        name: 'LoansUser',
        components: {site: SiteTemplate},
        beforeEnter: multiguard([loginRequired, needPhoneVerification]),
    },
    {
        path: '/dashboard/loan/items/user/:user/order/:order',
        name: 'LoanItems',
        components: {site: SiteTemplate},
        beforeEnter: multiguard([loginRequired, needPhoneVerification]),
    },
    {
        path: '/dashboard/languages',
        name: 'Languages',
        components: {site: SiteTemplate},
        beforeEnter: multiguard([loginRequired, needPhoneVerification]),
    },
    {
        path: '/dashboard/multiple-stores',
        name: 'MultipleStores',
        components: {site: SiteTemplate},
        beforeEnter: multiguard([loginRequired, needPhoneVerification]),
    },
    {
        path: '/dashboard/chat',
        name: 'Chats',
        components: {site: SiteTemplate},
        beforeEnter: multiguard([loginRequired]),
    },
    {
        path: '/dashboard/user/chats/user',
        name: 'UserChats',
        components: {site: SiteTemplate},
        beforeEnter: multiguard([loginRequired]),
    },
    {
        path: '/statistic',
        name: 'Statistic',
        components: {site: SiteTemplate},
        beforeEnter: multiguard([loginRequired]),
    },
    {
        path: '/store-dashboard',
        name: 'StoreDashboard',
        component: SiteTemplate,
        beforeEnter: multiguard([loginRequired]),
    },
    {
        path: '/store-dashboard/products',
        name: 'StoreDashboardProducts',
        components: {site: SiteTemplate},
        beforeEnter: multiguard([loginRequired, needPhoneVerification]),
    },
    {
        path: '/store-dashboard/product/create',
        name: 'CreateStoreProduct',
        components: {site: SiteTemplate},
        beforeEnter: multiguard([loginRequired, needPhoneVerification]),
    },
]


export let siteRoutes = [
    {
        path: '/site-layout',
        name: 'SiteLayout',
        component: SiteTemplate,
        children: [
            ...siteRoutesTemplateChild,
            ...dashboardRoutesTemplateChild
        ]
    },
]